import {decodeJson} from "@2d-front-monorepo/core";
import ICustomData from "./interfaces/ICustomData.js";

function getCustomDataIndex(customData: ICustomData, key: string): number {
	let cd = customData.customData;
	let total = cd.length;
	let lowerKey = key.toLowerCase();
	for (let index = 0; index < total; ++index) {
		if (cd[index].key.toLowerCase() === lowerKey) {
			return index;
		}
	}
	return -1;
}

class CustomData {
	static containsKey(customData: ICustomData, key: string): boolean {
		return getCustomDataIndex(customData, key) >= 0;
	}

	static get(customData: ICustomData, key: string): string | undefined {
		const index = getCustomDataIndex(customData, key);
		return index >= 0 ? customData.customData[index].value : undefined;
	}

	static getObject<T>(customData: ICustomData, key: string): T | undefined {
		const value = this.get(customData, key);
		if (value == null) return undefined;
		return decodeJson<T>(value);
	}

	static remove(customData: ICustomData, key: string): void {
		const index = getCustomDataIndex(customData, key);
		if (index === -1) {
			return;
		}
		customData.customData.splice(index, 1);
	}

	static set(customData: ICustomData, key: string, value: string): void {
		const index = getCustomDataIndex(customData, key);
		if (index >= 0) {
			customData.customData[index].value = value;
		} else {
			customData.customData.push({key, value: value});
		}
	}

	static toggle(customData: ICustomData, key: string, state: boolean): void {
		if (state) {
			this.set(customData, key, "true");
		} else {
			this.remove(customData, key);
		}
	}

	static setObject<T>(customData: ICustomData, key: string, value: T): void {
		const index = getCustomDataIndex(customData, key);
		const json = JSON.stringify(value);
		if (index >= 0) {
			customData.customData[index].value = json;
		} else {
			customData.customData.push({key, value: json});
		}
	}
}

export {CustomData};
